import colors from '../globals/colors';
var curriculum = {
  sidebar: colors.primary.normal,
  conocimientos: {
    basico: colors.primary.normal,
    intermedio: '#E42430',
    avanzado: '#7000C8',
    experto: colors.secondary.normal
  }
};
export default curriculum;